import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AdmissionService } from 'src/app/private/services/admission.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-add-admission',
  templateUrl: './add-admission.component.html',
  standalone: true,
  imports: [
    SharedModule
  ]
})
export class AddAdmissionComponent {

  @Output() closeDialog: EventEmitter<void> = new EventEmitter<void>();
  @Output() reload: EventEmitter<void> = new EventEmitter<void>();

  createFieldFormValue: any = {
    prefix: null,
    first_name: '',
    last_name: '',
    email: '',
    date_of_birth: null,
    age: null,
    gender: null,
    blood_group: null,
    nationality: '',
    address: '',
    city: '',
    state: '',
    country: '',
    postal_code: '',
    phone: '',
    alternate_phone: '',
    guardian_name: '',
    guardian_contact: '',
    previous_education: '',
    admission_number: '',
    admission_date: new Date(),
    academic_year_id: null,
    session: '',
    course_id: null,
    department_id: null,
    batch_id: null,
    admission_status: '',
    admission_type: '',
    category: '',
    fee_group_id: null,
    hostel_required: false,
    hostel_category: null,
    transport_required: false,
    transport_category: null,
    admission_mode: '',
    admission_source: '',
    assigned_to: null,
    remarks: '',
    scholarship_category: null
  };

  isSubmitted: boolean = false;
  isLoading: boolean = false;
  formAction: string = 'Add';
  today: Date = new Date();
  fieldValues: any = {};

  prefixOptions = [
    { label: 'Mr', value: 'Mr' },
    { label: 'Mrs', value: 'Mrs' },
    { label: 'Ms', value: 'Ms' },
    { label: 'Dr', value: 'Dr' }
  ];

  genderOptions = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Other', value: 'Other' }
  ];

  bloodGroupOptions = [
    { label: 'A+', value: 'A+' },
    { label: 'A-', value: 'A-' },
    { label: 'B+', value: 'B+' },
    { label: 'B-', value: 'B-' },
    { label: 'O+', value: 'O+' },
    { label: 'O-', value: 'O-' },
    { label: 'AB+', value: 'AB+' },
    { label: 'AB-', value: 'AB-' }
  ];

  sessionOptions = [
    { label: 'Fall', value: 'Fall' },
    { label: 'Spring', value: 'Spring' },
    { label: 'Summer', value: 'Summer' },
    { label: 'Winter', value: 'Winter' }
  ];

  admissionStatusOptions = [
    
    { value: 'Under Review', label: 'Under Review' },
    { value: 'Approved', label: 'Approved' },
    { value: 'Rejected', label: 'Rejected' },
    { value: 'Waitlisted', label: 'Waitlisted' },
  ];

  admissionTypeOptions = [
    { label: 'Regular', value: 'Regular' },
    { label: 'Transfer', value: 'Transfer' },
    { label: 'Lateral', value: 'Lateral' },
    { label: 'Readmission', value: 'Readmission' },
    { label: 'Dropout', value: 'Dropout' },
  ];

  categoryOptions = [
    { label: 'General', value: 'General' },
    { label: 'SC', value: 'SC' },
    { label: 'ST', value: 'ST' },
    { label: 'OBC', value: 'OBC' }
  ];

  admissionModeOptions = [
        { label: 'Online', value: 'Online' },
    { label: 'Offline', value: 'Offline' },
    { label: 'Hybrid', value: 'Hybrid' }
  ];

  admissionSourceOptions = [
    { label: 'Channel Partner', value: 'Channel Partner' },
    { label: 'Conference', value: 'Conference' },
    { label: 'Field Visit', value: 'Field Visit' },
    { label: 'Google', value: 'Google' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
    { label: 'Live Session', value: 'Live Session' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Referral', value: 'Referral' },
    { label: 'LinkedIn', value: 'LinkedIn' },
    { label: 'Website', value: 'Website' },
    { label: 'WhatsApp', value: 'WhatsApp' },
    { label: 'Tina', value: 'Tina' },
    { label: 'Intern', value: 'Intern' },
    { label: 'Other', value: 'Other' }
  ];


  @Input() academicYears: any[] = []; // Populate from service
  @Input() courses: any[] = []; // Populate from service
  @Input() departments: any[] = []; // Populate from service
  @Input() batches: any[] = []; // Populate from service
  @Input() feeGroups: any[] = []; // Populate from service
  @Input() hostelCategories: any[] = []; // Populate from service
  @Input() transportCategories: any[] = []; // Populate from service
  @Input() users: any[] = []; // Populate from service
  @Input() scholarshipTypes: any[] = []; // Populate from service
  @Input() allLeadFeilds: any[] = []; // Dynamic fields

  constructor(
    private api: AdmissionService,
    private messageService: MessageService,
    private localStorage: LocalStorageService
  ) { }

  ngOnInit() {
    this.users = this.users.map((user: any) => {
      return {
        label: user.fname + " " + user.lname,
        value: user?.user_id
      };
    });
  }


  handleCloseDialog() {
    this.closeDialog.emit();
  }

  onSubmit(isValid: boolean) {
    this.isSubmitted = true;

    if (!isValid) {
      return;
    }

    this.isLoading = true;

    // Process form submission
    const admissionData = {
      ...this.createFieldFormValue,
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };


    this.api.addAdmission(admissionData).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Admission added successfully' });
        this.reload.emit();
        this.handleCloseDialog();
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to add admission' });
      }

    });
  }
}
